import Clarity from '@microsoft/clarity';
import { EnvironmentManager } from '../EnvironmentManager/EnvironmentManager';

export class GGAnalyticsManager {

    // Current provider of analytics is Clarity
    public static logEvent(eventName: string): void {
        // Logging enabled only for Production environment
        if (EnvironmentManager.isProdEnv()) {
            Clarity.event(eventName);
        }
    }

}

const logAnalyticsEvent = GGAnalyticsManager.logEvent; // for easy import
export default logAnalyticsEvent;